export const FETCH_SEARCHWAREHOUSE_INIT = 'WAREHOUSE::FETCH_SEARCHWAREHOUSE_INIT';
export const FETCH_WAREHOUSE_SUCCESS = 'WAREHOUSE::FETCH_WAREHOUSE_SUCCESS';
export const FETCH_WAREHOUSE_ERROR = 'WAREHOUSE::FETCH_WAREHOUSE_ERROR';
export const CLEAR_WAREHOUSE_STATE = 'WAREHOUSE::CLEAR_WAREHOUSE_STATE'